import React from 'react';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Paper, Typography} from '@mui/material';
import AppLogo from '../ui/AppLogo';

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
  },
  logogrid: {
    //marginTop: -40,
    //marginLeft: -210
  },
  textWhite: {
    color: theme.palette.landing.text,
  },
  spinny: {
    marginTop: 12,
    marginLeft: -12,
  },
  logoWrapper: {
    width: 132,
    height: 132,
    marginBottom: -66,
    position: 'relative',
    zIndex: 20,
    display: 'flex',
    webkitBoxPack: 'center',
    webkitJustifyContent: 'center',
    msFlexPack: 'center',
    justifyContent: 'center',
    webkitBoxAlign: 'center',
    webkitAlignItems: 'center',
    msFlexAlign: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    backgroundColor: '#fff',
    // box-shadow: 0 1px 3px 0 rgba(89, 98, 115, .2);
  },
  block1: {
    width: 670,
    height: 260,
    justifyContent: 'center',
    display: 'flex',
    overflow: 'hidden',
    flexWrap: 'nowrap',
    flex: 0,
    borderRadius: 16,
    backgroundImage: 'radial-gradient(circle farthest-corner at 50% 50%, #00538a, hsla(206.88524590163937, 100.00%, 35.88%, 1.00))',
  },
  block1cs: {
    position: 'absolute',
    top: -250,
    width: 670,
    height: 670,
    borderRadius: '50%',
    opacity: 0.15,
  },
  block1c1: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: 'block',
    width: '30%',
    height: '30%',
    margin: 'auto',
    border: '2px solid #fff',
    borderRadius: '50%',
    opacity: 0.85,
  },
  block1c2: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: 'block',
    width: '40%',
    height: '40%',
    margin: 'auto',
    border: '2px solid #fff',
    borderRadius: '50%',
    opacity: 0.7,
  },
  block1c3: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: 'block',
    width: '50%',
    height: '50%',
    margin: 'auto',
    border: '2px solid #fff',
    borderRadius: '50%',
    opacity: 0.6,
  },
  block1c4: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: 'block',
    width: '60%',
    height: '60%',
    margin: 'auto',
    border: '2px solid #fff',
    borderRadius: '50%',
    opacity: 0.5,
  },
  block1c5: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: 'block',
    width: '70%',
    height: '70%',
    margin: 'auto',
    border: '2px solid #fff',
    borderRadius: '50%',
    opacity: 0.4,
  },
  block1c6: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: 'block',
    width: '80%',
    height: '80%',
    margin: 'auto',
    border: '2px solid #fff',
    borderRadius: '50%',
    opacity: 0.3,
  },
  block1c7: {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 10,
    display: 'block',
    width: '90%',
    height: '90%',
    margin: 'auto',
    border: '2px solid #fff',
    borderRadius: '50%',
    opacity: 0.2,
  },
  b1title: {
    marginTop: 40,
    textAlign: 'center',
  },
  b1body: {
    marginTop: 4,
    textAlign: 'center',
  },
  b1buttons: {
    marginTop: 8,
  },
  block2: {
    //padding: theme.spacingunit * 3,
    padding: 20,
    paddingBottom: 40,
    color: theme.palette.text.secondary,
    // maxWidth: 980,
    marginTop: 48,
    //marginLeft: -210
  },
  b2title: {
    marginTop: 32,
    textAlign: 'center',
  },
  b2body: {
    marginTop: 16,
    textAlign: 'center',
  },
  b2flow: {
    marginTop: 48,
    textAlign: 'center',
  },
  b2steps: {
    marginTop: 48,
  },
  b2step: {
    width: 240,
  },
  block3: {
    //padding: theme.spacingunit * 3,
    padding: 20,
    paddingBottom: 40,
    color: theme.palette.text.secondary,
    // maxWidth: 980,
    // marginTop: 48,
    //marginLeft: -210
  },
  b3head: {
    marginTop: 32,
    textAlign: 'center',
  },
  b3title: {
    marginTop: 16,
    marginBottom: 16,
    textAlign: 'center',
  },
  b3body: {
    marginTop: 16,
    textAlign: 'center',
  },
  b3qa: {
    marginTop: 16,
    marginLeft: 48,
  }
});

class LandingPreview extends React.Component {
  state = {
    
  }

  render() {

    const { landingLogo, landingTitle, landingText, 
      signupText, partnerLink, partnerLinkText } = this.props;
    const classes = this.props.classes;

    let theLogo = null;
    if (landingLogo != null) {
      theLogo = landingLogo;
    }

    //let signupLink = '/signup?app=' + linkParameter;

    let b1Title = 'Buy and sell apps';
    if (landingTitle !== "") {
      b1Title = landingTitle;
    }

    let b1Body = 'Manage subscriptions for your clients painlessly.';
    if (landingText !== "") {
      b1Body = landingText;
    }

    let b1SignupText = 'Set up partner billing';
    if (signupText !== "") {
      b1SignupText = signupText;
    }

    let b1PartnerLinkText = 'Become a partner';
    if (partnerLinkText !== "") {
      b1PartnerLinkText = partnerLinkText;
    }

    let b2signupText = 'Sign up on behalf of your client.';
    if (partnerLink !== "") {
      b2signupText = b2signupText + ' Use your own referral links too!';
    }

    return (
      <div className={classes.root}>
        <Grid container direction="column" justifyContent="center">
          <Grid item>
            <Grid container spacing={0} direction="row" justifyContent="center" className={classes.logogrid}>
              <Grid item>
                <div className={classes.logoWrapper}>
                  <AppLogo logoPath={theLogo} appName="App" imageHeight='80px'/>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={2} direction="row" justifyContent="center">
              <Grid item>
                <div className={classes.block1}>
                  <div className={classes.block1cs}>
                    <div className={classes.block1c1}></div>
                    <div className={classes.block1c2}></div>
                    <div className={classes.block1c3}></div>
                    <div className={classes.block1c4}></div>
                    <div className={classes.block1c5}></div>
                    <div className={classes.block1c6}></div>
                    <div className={classes.block1c7}></div>
                  </div>
                  <Grid container spacing={2} direction="column" justifyContent="center">
                    <Grid item className={classes.b1title}>
                      <Typography className={classes.textWhite} variant="h3">{b1Title}</Typography>
                    </Grid>
                    <Grid item className={classes.b1body}>
                      <Typography className={classes.textWhite} variant="body1">{b1Body}</Typography>
                    </Grid>
                    <Grid item>
                      <Grid container spacing={2} direction="row" justifyContent="center" className={classes.b1buttons}>
                        <Grid item>
                          <Button color="primary" variant="contained"
                                  onClick={() => { alert('This would allow reseller to sign up'); }}>
                            {b1SignupText}
                          </Button>
                        </Grid>
                        { partnerLink != null &&
                        <Grid item>
                          <Button className={classes.textWhite} color="secondary" variant="outlined"
                                  onClick={() => { window.open(partnerLink, '_blank'); }}>
                            {b1PartnerLinkText}
                          </Button>
                        </Grid>
                        }
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Paper className={classes.block2}>
          <Grid container direction="column" justifyContent="center">
            <Grid item className={classes.b2title}>
              <Typography variant="h4">Decide who pays &mdash; you or your client</Typography>
            </Grid>
            <Grid item className={classes.b2body}>
              <Typography variant="body1">Why juggle expenses for your clients?  Pass subscription charges
              on automatically.</Typography>
            </Grid>
            <Grid item className={classes.b2flow}>
              <img alt="PaymentFlow" src={'/images/payment-flow.png'}/>
            </Grid>
            <Grid item className={classes.b2steps}>
              <Grid container spacing={2} direction="row" justifyContent="space-around">
                <Grid item className={classes.b2step}>
                  <Typography variant="h6">1. Sign up</Typography>
                  <Typography variant="body1">{b2signupText}</Typography>
                </Grid>
                <Grid item className={classes.b2step}>
                  <Typography variant="h6">2. Create a credit card</Typography>
                  <Typography variant="body1">The magic is creating a unique AppBind credit card for each subscription.</Typography>
                </Grid>
                <Grid item className={classes.b2step}>
                  <Typography variant="h6">3. Decide who pays</Typography>
                  <Typography variant="body1">For each subscription, you decide who pays: you or your client.</Typography>
                </Grid>
                <Grid item className={classes.b2step}>
                  <Typography variant="h6">4. Add your markup</Typography>
                  <Typography variant="body1">Optionally earn revenue by adding your management fees.  Typically 20%.</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
        <Paper className={classes.block3}>
          <Grid container direction="column" justifyContent="center">
            <Grid item className={classes.b3head}>
              <Typography variant="subtitle1">YOU ASKED, WE ANSWERED</Typography>
            </Grid>
            <Grid item className={classes.b3title}>
              <Typography variant="h4">Frequently Asked Questions</Typography>
            </Grid>
          </Grid>
          <Grid container direction="column" justifyContent="flex-start">
            <Grid item className={classes.b3qa}>
              <Typography variant="h6">Q: How much does this cost?</Typography>
              <Typography variant="body1">1% plus payment network fees.  No setup, monthly, nor hidden fees.  Pay only for what you use.</Typography>
            </Grid>
            <Grid item className={classes.b3qa}>
              <Typography variant="h6">Q: How much are the payment network fees?</Typography>
              <Typography variant="body1">If you pay with credit cards, it is usually 2.9% + $0.30 but could be as high as 4%.
                If you use ACH (direct bank payment), it is only $0.50.</Typography>
            </Grid>
            <Grid item className={classes.b3qa}>
              <Typography variant="h6">Q: Who owns the subscription?</Typography>
              <Typography variant="body1">That's between you and your clients.  You can create the AppBind
                card and sign up for subscriptions in your client's name as their agent or on your own account.</Typography>
            </Grid>
            <Grid item className={classes.b3qa}>
              <Typography variant="h6">Q: Will this work internationally?</Typography>
              <Typography variant="body1">Yes. You can be anywhere in the world that we can
                accept payment from.</Typography>
            </Grid>
          </Grid>
        </Paper>
      </div>
    );

      } 
 
  }



LandingPreview.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(LandingPreview);
